import React from 'react';
import SubscriberListPage from 'app/Components/Block/PremiumPackagesCatalogBlock/Pages/SubscriberListPage';
import 'app/Components/Block/PremiumPackagesCatalogBlock/premiumPackagesCatalog.scss';

const SubscriberListPageWrapper = (props) => {
  return (
    <div className="premium-packages-catalog-block">
      <div className="premium-packages-catalog-wrapper">
        <SubscriberListPage {...props} />
      </div>
    </div>
  );
};

export default SubscriberListPageWrapper;
